import UrlTypes from '@/enums/UrlTypes';

/**
 * KBS provider URL classification.
 */
export function classifyKbsUrl(loc: string): UrlTypes {
    const normalizedLoc = loc.toLowerCase().trim();
    if (normalizedLoc.includes('/categories/')) {
        return UrlTypes.CATEGORY;
    }
    if (normalizedLoc.includes('/products/')) {
        return UrlTypes.PRODUCT;
    }
    if (normalizedLoc.includes('pages/')) {
        return UrlTypes.PAGE;
    }
    return UrlTypes.OTHER;
}
